// extracted by mini-css-extract-plugin
export default {"container":"timerheader_container__zq4k5","name":"timerheader_name__A4EYo"};